var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownGreenArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71967 8.71967C4.01256 8.42678 4.48744 8.42678 4.78033 8.71967L7.25 11.1893L9.71967 8.71967C10.0126 8.42678 10.4874 8.42678 10.7803 8.71967C11.0732 9.01256 11.0732 9.48744 10.7803 9.78033L7.78033 12.7803C7.48744 13.0732 7.01256 13.0732 6.71967 12.7803L3.71967 9.78033C3.42678 9.48744 3.42678 9.01256 3.71967 8.71967Z",
    fill: "#0BAA50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 0.994706C7.66421 0.994706 8 1.33049 8 1.74471L8 10.8033C8 11.2175 7.66421 11.5533 7.25 11.5533C6.83579 11.5533 6.5 11.2175 6.5 10.8033L6.5 1.74471C6.5 1.33049 6.83579 0.994706 7.25 0.994706Z",
    fill: "#0BAA50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownGreenArrow);
export default __webpack_public_path__ + "static/media/down-green-arrow.8129bb1b.svg";
export { ForwardRef as ReactComponent };